import React from "react"
import { connect } from "react-redux"
import { formValueSelector } from "redux-form"
import { FORM_NAMES } from "constants/index"
import PhoneArea from "components/PhonePreview/PhoneArea"
import ButtonStack from "./LayoutPreviews/buttonStack"
import Curbside from "./LayoutPreviews/curbside"
import SimpleStack from "./LayoutPreviews/simpleStack"
import Dialpad from "./LayoutPreviews/dialpad"
import Circles from "./LayoutPreviews/circles"

const PhonePreview = ({ step1FormValues = {}, selectedEvent }) => {
  const bgUrl =
    step1FormValues?.bgImageType === "2" &&
    step1FormValues?.bgImage?.editedImage
      ? `url(${step1FormValues?.bgImage?.editedImage})`
      : `url(${selectedEvent?.design?.default_bg_image_url})`
  const thumbnailUrl =
    step1FormValues?.thumbnailImageType === "2" &&
    step1FormValues?.thumbnailImage?.editedImage
      ? `url(${step1FormValues?.thumbnailImage?.editedImage})`
      : `url(${selectedEvent?.design?.default_event_thumbnail_url})`
  const name = step1FormValues?.name
  const textColor = step1FormValues?.textColor
  const menuColor = step1FormValues?.menuColor
  const menuItems = selectedEvent?.design?.menu || []
  const font = step1FormValues?.font
  const renderPreview = () => {
    switch (step1FormValues?.layout) {
      case "1":
        return (
          <ButtonStack
            bgUrl={bgUrl}
            name={name}
            textColor={textColor}
            thumbnailUrl={thumbnailUrl}
            menuItems={menuItems}
            font={font}
            menuColor={menuColor}
          />
        )
      case "2":
        return (
          <Dialpad
            bgUrl={bgUrl}
            name={name}
            textColor={textColor}
            thumbnailUrl={thumbnailUrl}
            menuColor={menuColor}
            menuItems={menuItems}
            font={font}
          />
        )
      case "3":
        return (
          <Curbside
            bgUrl={bgUrl}
            name={name}
            textColor={textColor}
            thumbnailUrl={thumbnailUrl}
            menuItems={menuItems}
            font={font}
            menuColor={menuColor}
          />
        )
      case "4":
        return (
          <SimpleStack
            bgUrl={bgUrl}
            name={name}
            textColor={textColor}
            thumbnailUrl={thumbnailUrl}
            menuItems={menuItems}
            font={font}
            menuColor={menuColor}
          />
        )
      case "6":
        return (
          <Circles
            bgUrl={bgUrl}
            name={name}
            textColor={textColor}
            thumbnailUrl={thumbnailUrl}
            menuItems={menuItems}
            font={font}
            menuColor={menuColor}
          />
        )
      default:
        return (
          <Dialpad
            bgUrl={bgUrl}
            name={name}
            textColor={textColor}
            thumbnailUrl={thumbnailUrl}
            menuColor={menuColor}
            menuItems={menuItems}
            font={font}
          />
        )
    }
  }

  return (
    <React.Fragment>
      <h5 style={{ textAlign: "center" }}>Preview</h5>
      <PhoneArea style={{ paddingLeft: "0px", paddingBottom: "0px" }}>
        {renderPreview()}
      </PhoneArea>
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.EXPERIENCE)

const mapStateToProps = state => ({
  step1FormValues: selector(state, "setup"),
  selectedEvent: state.experiences.selectedEvent,
})

export default connect(mapStateToProps)(PhonePreview)
